import * as React from "react";

const IconTextLinkPencilEditInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15">
            <path
                fill="currentColor"
                d="M13.486 2.288 12.46 1.263a1.744 1.744 0 0 0-2.473 0L.849 10.378a.438.438 0 0 0-.12.223l-.72 3.601c-.056.277.16.548.427.548a.444.444 0 0 0 .088-.009l3.6-.72a.438.438 0 0 0 .224-.12l9.14-9.14c.684-.683.681-1.789-.002-2.473Zm-9.88 10.499-2.054.41.41-2.054.663-.661v1.643h1.644l-.662.662Zm.331-1.975V9.17l4.838-4.815 1.643 1.644-4.837 4.814H3.937Z"
            />
        </svg>
    );
};

export default React.memo(IconTextLinkPencilEditInactive);
